import { gql } from '@apollo/client';

const DELETE_HELP_TOPIC = gql`mutation deleteHelpTopic($topicId: Int!) {
  helpContext {
    deleteHelpTopic(topicId: $topicId) {
			success
			message
      topicId: id
    }
  }
}`;

export default DELETE_HELP_TOPIC;
